/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/settingsHelpers.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Helper functions for extracting settings values.
────────────────────────────────────────────────────────────────*/

/**
 * Gets setting value from settings array or object
 */
export function getSettingValue(settings: Array<{ name: string; value?: unknown }> | Record<string, unknown> | null | undefined, name: string): string {
  if (!settings) return '';

  if (Array.isArray(settings)) {
    const match = settings.find((item) => item?.name === name);
    if (match) {
      return String(match.value ?? '');
    }
  } else if (typeof settings === 'object') {
    return String(settings[name] ?? '');
  }

  return '';
}


